"use strict";

exports.__esModule = true;
exports.HistoricalPartCountController = void 0;
var _react = require("react");
var _API = require("../../API");
var _UI = require("../../../Utils/UI");
var _Translator = require("../../Core/Translator");
var _dec, _class, _HistoricalPartCountController;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var HistoricalPartCountController = exports.HistoricalPartCountController = (_dec = _API.RestAPIContext.withContext, _dec(_class = (0, _Translator.withTranslator)(_class = (_HistoricalPartCountController = /*#__PURE__*/function (_Component) {
  function HistoricalPartCountController() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      loading: false,
      deleteHistoricalPartCount: function () {
        var _deleteHistoricalPartCount = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(id) {
          var _this$props, api, translate, _t;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.p = _context.n) {
              case 0:
                _this$props = _this.props, api = _this$props.api, translate = _this$props.translator.translate;
                _context.p = 1;
                _context.n = 2;
                return api["delete"]("/api/v1/part-count/part-count/" + id);
              case 2:
                (0, _UI.showSuccessToaster)(translate("DeleteHistoricalPartCount.save.success", "Part count delete queued successfully"));
                _context.n = 4;
                break;
              case 3:
                _context.p = 3;
                _t = _context.v;
                (0, _UI.showErrorToaster)(translate("DeleteHistoricalPartCount.save.error", "Failed to delete part count"));
                console.warn(_t);
              case 4:
                return _context.a(2);
            }
          }, _callee, null, [[1, 3]]);
        }));
        function deleteHistoricalPartCount(_x) {
          return _deleteHistoricalPartCount.apply(this, arguments);
        }
        return deleteHistoricalPartCount;
      }(),
      updateHistoricalPartCount: function () {
        var _updateHistoricalPartCount = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(id, goodPartCount, badPartCount) {
          var _this$props2, api, translate, response, _t2;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.p = _context2.n) {
              case 0:
                _this$props2 = _this.props, api = _this$props2.api, translate = _this$props2.translator.translate;
                _context2.p = 1;
                _context2.n = 2;
                return api.put("/api/v1/part-count/part-count/" + id, {
                  goodPartCount: goodPartCount,
                  badPartCount: badPartCount
                });
              case 2:
                response = _context2.v;
                (0, _UI.showSuccessToaster)(translate("UpdateHistoricalPartCount.save.success", "Part count update queued successfully"));
                return _context2.a(2, response);
              case 3:
                _context2.p = 3;
                _t2 = _context2.v;
                (0, _UI.showErrorToaster)(translate("UpdateHistoricalPartCount.save.error", "Failed to update part count"));
                console.warn(_t2);
                return _context2.a(2, _t2);
            }
          }, _callee2, null, [[1, 3]]);
        }));
        function updateHistoricalPartCount(_x2, _x3, _x4) {
          return _updateHistoricalPartCount.apply(this, arguments);
        }
        return updateHistoricalPartCount;
      }(),
      updateHistoricalPartShiftCount: function () {
        var _updateHistoricalPartShiftCount = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(_ref) {
          var dateFrom, dateTo, device, workday, shift, partKind, partProcess, elementCount, goodPartCount, badPartCount, _this$props3, api, translate, response, _t3;
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.p = _context3.n) {
              case 0:
                dateFrom = _ref.dateFrom, dateTo = _ref.dateTo, device = _ref.device, workday = _ref.workday, shift = _ref.shift, partKind = _ref.partKind, partProcess = _ref.partProcess, elementCount = _ref.elementCount, goodPartCount = _ref.goodPartCount, badPartCount = _ref.badPartCount;
                _this$props3 = _this.props, api = _this$props3.api, translate = _this$props3.translator.translate;
                _context3.p = 1;
                _context3.n = 2;
                return api.put("/api/v1/part-count/part-counts/shift", {
                  dateFrom: dateFrom,
                  dateTo: dateTo,
                  device: device,
                  workday: workday,
                  shift: shift,
                  partKind: partKind,
                  partProcess: partProcess,
                  elementCount: elementCount,
                  goodPartCount: goodPartCount,
                  badPartCount: badPartCount
                });
              case 2:
                response = _context3.v;
                (0, _UI.showSuccessToaster)(translate("UpdateHistoricalPartCountByShift.save.success", "Shift part count update queued successfully"));
                return _context3.a(2, response);
              case 3:
                _context3.p = 3;
                _t3 = _context3.v;
                (0, _UI.showErrorToaster)(translate("UpdateHistoricalPartCountByShift.save.error", "Failed to update shift part count"));
                console.warn(_t3);
                return _context3.a(2, _t3);
            }
          }, _callee3, null, [[1, 3]]);
        }));
        function updateHistoricalPartShiftCount(_x5) {
          return _updateHistoricalPartShiftCount.apply(this, arguments);
        }
        return updateHistoricalPartShiftCount;
      }()
    };
    return _this;
  }
  _inheritsLoose(HistoricalPartCountController, _Component);
  var _proto = HistoricalPartCountController.prototype;
  _proto.render = function render() {
    return this.props.children(this.state);
  };
  return HistoricalPartCountController;
}(_react.Component), _HistoricalPartCountController.defaultProps = {
  api: undefined
}, _HistoricalPartCountController)) || _class) || _class);
HistoricalPartCountController.displayName = "HistoricalPartCountController";